module.exports = __webpack_public_path__ + "static/media/ic_categories_book.2d2f9da4.svg";